import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DocumenteCetateanAddPayload, DocumenteCetateanEditPayload } from './documente-cetatean.interface';

@Injectable({
    providedIn: 'root'
})
export class DocumenteCetateanService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private storeDocumentCetateanUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.storeDocumentCetatean;
    private updateDocumentCetateanUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.updateDocumentCetatean;
    private getCnpUrl = this.basePath + environment.interop.platform.nomenclatoare.citizen.searchCnp;
    private fileUploadUrl = this.basePath + environment.interop.platform.nomenclatoare.cereri.uploadFileRegister;
    private validateDocumentCetateanUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.validateDocumentCetatean;
    private resetValidateDocumentCetateanUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.resetValidateDocumentCetatean;
    private cancelDocumentCetateanUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.cancelDocumentCetatean;
    private resetCancelDocumentCetateanUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.resetCancelDocumentCetatean;
    public fileDownloadUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.fileDownload;
    private addFilesUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.addFiles;
    private deleteFilesUrl = this.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.deleteFiles;

    constructor(private http: HttpClient) { }

    addDocumentCetatean(data: DocumenteCetateanAddPayload) {
        return this.http.post(this.storeDocumentCetateanUrl, data, this.httpOptions);
    }

    updateDocumentCetatean(data: DocumenteCetateanEditPayload) {
        return this.http.put(this.updateDocumentCetateanUrl, data, this.httpOptions);
    }

    getCnp(cnp: string) {
        return this.http.post(this.getCnpUrl, { search: cnp });
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    validateDocumentCetatean(id: number, data: string) {
        return this.http.post(this.validateDocumentCetateanUrl + id, { observatii: data });
    }

    resetValidateDocumentCetatean(id: number, data: any) {
        return this.http.get(this.resetValidateDocumentCetateanUrl + id, data);
    }

    cancelDocumentCetatean(id: number, data: string) {
        return this.http.post(this.cancelDocumentCetateanUrl + id, { observatii: data });
    }

    resetCancelDocumentCetatean(id: number, data: any) {
        return this.http.get(this.resetCancelDocumentCetateanUrl + id, data);
    }

    addFiles(id: number, data: any) {
        return this.http.post(this.addFilesUrl + id, data);
    }

    deleteFiles(data: any) {
        return this.http.post(this.deleteFilesUrl, data);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

}
